// Switch desktop nav submenus from hover-open to click-open.
// Uses $(document).ready so this runs immediately after headerMenu.js's own
// ready callback (custom.js is deferred and appears later in the document),
// eliminating the gap that window.load left where hover still worked.
$(document).ready(function () {
  if (typeof $ === "undefined") return;

  var $triggers = $("[data-top-menu-category-id]");

  // Remove hover/focus handlers bound by headerMenu.js.
  // 'focus' must be included — headerMenu.js binds all three together and
  // clicking a button gives it focus, which was opening the submenu.
  $triggers.off("mouseenter mouseleave touchstart focus");
  $("[data-sub-menu-category-id] .main-menu__sub-menu").off(
    "mouseenter mouseleave",
  );

  var $container = $(".main-menu__sub-menu-container");

  function closeAll() {
    $container
      .addClass("main-menu__sub-menu-container--hidden")
      .attr("aria-hidden", "true");
    $(".main-menu__sub-menu-wrapper").addClass(
      "main-menu__sub-menu-wrapper--hidden",
    );
    $triggers.attr("aria-expanded", "false");
    $(".sub-menu__tab--active").removeClass("sub-menu__tab--active");
    $(".sub-menu__grandchildren-panel").removeClass("is-open");
    $(".sub-menu__grandchildren.is-active").removeClass("is-active");
  }

  // ── Tier-3 group accordion (shared desktop + mobile) ──────────────────────
  // Strict accordion: at most one .nav-acc__collapse open per panel container
  // (.sub-menu__grandchildren on desktop, .mobile-subnav__tier2-panel on
  // mobile). Clicking the open section's heading collapses it.

  function syncAccToggles($container) {
    $container.find(".js-nav-acc-toggle").each(function () {
      var open = $(this).next(".nav-acc__collapse").hasClass("is-open");
      $(this).attr("aria-expanded", open ? "true" : "false");
    });
  }

  function toggleAccSection($toggle) {
    var $section = $toggle.next(".nav-acc__collapse");
    var $scope = $toggle.closest(
      ".sub-menu__grandchildren, .mobile-subnav__tier2-panel",
    );
    var wasOpen = $section.hasClass("is-open");
    $scope.find(".nav-acc__collapse.is-open").removeClass("is-open");
    if (!wasOpen) $section.addClass("is-open");
    syncAccToggles($scope);
  }

  // Default state: first section open, rest closed. Called on every panel
  // activation so a fiddled-with accordion resets on reopen.
  function resetNavAccordion($container) {
    $container.find(".nav-acc__collapse").removeClass("is-open");
    $container.find(".nav-acc__collapse").first().addClass("is-open");
    syncAccToggles($container);
  }

  $(document).on("click", ".js-nav-acc-toggle", function (e) {
    e.preventDefault();
    e.stopPropagation();
    toggleAccSection($(this));
  });

  // Reveal a tier-2 tab's grandchildren panel. Shared by tier-2 tab clicks and
  // by the tier-1 open path (which auto-reveals the first tab).
  function activateTab($tab) {
    var tabId = $tab.data("tab-id");
    var $subMenu = $tab.closest(".main-menu__sub-menu");
    var $panel = $subMenu.find(".sub-menu__grandchildren-panel");

    $subMenu.find(".sub-menu__tab").removeClass("sub-menu__tab--active");
    $panel.find(".sub-menu__grandchildren").removeClass("is-active");

    $tab.addClass("sub-menu__tab--active");
    $panel
      .find('[data-grandchildren-id="' + tabId + '"]')
      .addClass("is-active");
    $panel.addClass("is-open");
    resetNavAccordion(
      $panel.find('[data-grandchildren-id="' + tabId + '"]'),
    );
  }

  $triggers.on("click.menu-click", function (e) {
    var $trigger = $(this);
    var categoryId = $trigger.data("top-menu-category-id");
    // The wrapper is a child of the container, not the other way around.
    var $wrapper = $('[data-sub-menu-category-id="' + categoryId + '"]');

    if (!$wrapper.length) return; // No submenu — let the link navigate normally

    e.preventDefault();
    e.stopPropagation();

    var isOpen = !$wrapper.hasClass("main-menu__sub-menu-wrapper--hidden");

    closeAll();

    if (!isOpen) {
      $container
        .removeClass("main-menu__sub-menu-container--hidden")
        .attr("aria-hidden", "false");
      $wrapper.removeClass("main-menu__sub-menu-wrapper--hidden");
      $trigger.attr("aria-expanded", "true");

      // Open with the first tier-2 group revealed, so the tray is never an
      // empty shelf. Items whose children are all flat links have no tabs to
      // reveal — they just open with their pills/links.
      var $firstTab = $wrapper.find(".sub-menu__tab[data-tab-id]").first();
      if ($firstTab.length) activateTab($firstTab);
    }
  });

  // Tier-2 tab clicks — reveal, or collapse if the active tab is re-clicked
  $(document).on("click.menu-click", ".sub-menu__tab[data-tab-id]", function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $tab = $(this);

    if ($tab.hasClass("sub-menu__tab--active")) {
      var $panel = $tab
        .closest(".main-menu__sub-menu")
        .find(".sub-menu__grandchildren-panel");
      $tab.removeClass("sub-menu__tab--active");
      $panel.find(".sub-menu__grandchildren").removeClass("is-active");
      $panel.removeClass("is-open");
    } else {
      activateTab($tab);
    }
  });

  // Close when clicking outside the nav
  $(document).on("click.menu-click", function (e) {
    if (
      !$(e.target).closest(
        "[data-top-menu-category-id], [data-sub-menu-category-id]",
      ).length
    ) {
      closeAll();
    }
  });

  // ESC to close
  $(document).on("keydown.menu-click", function (e) {
    if (e.key === "Escape") closeAll();
  });

  // ── Mobile popup menu ─────────────────────────────────────────────────────
  // Overrides shop.js width-toggle animation with show/hide popup behaviour.
  var $mobileWrapper = $("#mobile_top_menu_wrapper");

  function closeMobilePopup() {
    $mobileWrapper.hide();
    $("[data-mobile-sub-menu-id]").hide();
    $("#mobile-popup-top-menu .category").removeClass("is-active");
  }

  // Unbind shop.js handler and replace with popup toggle
  $("#menu-icon")
    .off("click")
    .on("click", function () {
      if ($mobileWrapper.is(":visible")) {
        closeMobilePopup();
      } else {
        $mobileWrapper.show();
        refreshHScroll($mobileWrapper);
      }
    });

  // ── Horizontal-scroll affordance (arrows + edge fade) ──────────────────
  // Toggles .can-scroll-left/right on a .hscroll-shell based on its
  // scroller's position. Scroller = the shell's first element child.
  function updateHScroll(shell) {
    var scroller = shell.firstElementChild;
    if (!scroller) return;
    var canLeft = scroller.scrollLeft > 1;
    var canRight =
      scroller.scrollLeft + scroller.clientWidth < scroller.scrollWidth - 1;
    $(shell)
      .toggleClass("can-scroll-left", canLeft)
      .toggleClass("can-scroll-right", canRight);
  }

  // Rows measure 0 while display:none — call after revealing a container.
  function refreshHScroll($scope) {
    $scope
      .find(".hscroll-shell")
      .addBack(".hscroll-shell")
      .each(function () {
        updateHScroll(this);
      });
  }

  // Live updates while swiping (scroll doesn't bubble — bind directly).
  $(".hscroll-shell").each(function () {
    var shell = this;
    $(shell.firstElementChild).on("scroll", function () {
      updateHScroll(shell);
    });
  });
  $(window).on("resize.hscroll", function () {
    refreshHScroll($("#mobile_top_menu_wrapper"));
  });

  // Arrow tap: page the row ~80% of its visible width.
  $(document).on("click", ".hscroll-arrow", function (e) {
    e.preventDefault();
    var shell = $(this).closest(".hscroll-shell")[0];
    var scroller = shell.firstElementChild;
    var dir = $(this).hasClass("hscroll-arrow--left") ? -1 : 1;
    var delta = dir * Math.round(scroller.clientWidth * 0.8);
    if (typeof scroller.scrollBy === "function") {
      scroller.scrollBy({ left: delta, behavior: "smooth" });
    } else {
      scroller.scrollLeft += delta;
    }
  });

  // Activate a mobile tier-2 tab: show its panel, then its first group tab.
  function activateMobileTier2($tab) {
    var $wrap = $tab.closest(".mobile-popup-submenu");
    var id = $tab.data("m-tier2");
    $wrap
      .find(".mobile-subnav__tier2-tab")
      .removeClass("mobile-subnav__tier2-tab--active");
    $tab.addClass("mobile-subnav__tier2-tab--active");
    $wrap.find(".mobile-subnav__tier2-panel").removeClass("is-active");
    var $panel = $wrap.find(
      '.mobile-subnav__tier2-panel[data-m-tier2-panel="' + id + '"]',
    );
    $panel.addClass("is-active");
    resetNavAccordion($panel);
    refreshHScroll($wrap);
  }

  // Submenu toggle inside the popup
  $(document).on("click", "[data-mobile-top-menu-id]", function (e) {
    var id = $(this).data("mobile-top-menu-id");
    var $sub = $("[data-mobile-sub-menu-id='" + id + "']");
    if (!$sub.length) return; // no submenu — allow link to navigate
    e.preventDefault();
    var isOpen = $sub.is(":visible");
    $("[data-mobile-sub-menu-id]").hide();
    $("#mobile-popup-top-menu .category").removeClass("is-active");
    if (!isOpen) {
      $sub.show();
      $(this).closest(".category").addClass("is-active");
      // Reset to the first tier-2 tab (and its first group tab) on each open.
      var $firstTab = $sub.find(".mobile-subnav__tier2-tab[data-m-tier2]").first();
      if ($firstTab.length) activateMobileTier2($firstTab);
      refreshHScroll($sub);
    }
  });

  // Mobile tier-2 tab tap
  $(document).on("click", ".mobile-subnav__tier2-tab[data-m-tier2]", function (e) {
    e.preventDefault();
    activateMobileTier2($(this));
  });

  // Close popup on overlay tap
  $(document).on("click", "#mobile_popup_overlay", function () {
    closeMobilePopup();
  });

  // Close popup after tapping a link inside it
  $(document).on("click", "#mobile_popup_panel a", function () {
    closeMobilePopup();
  });

  // ESC to close popup
  $(document).on("keydown.mobile-popup", function (e) {
    if (e.key === "Escape" && $mobileWrapper.is(":visible")) closeMobilePopup();
  });
});

// ── Mobile filter group label remapping ────────────────────────────────────
// Replaces raw Shopify storefront filter labels in the mobile Sort/Filter panel
// with human-readable group names from the collection's custom.filter_group
// metafield. Re-applied after every CollectionFiltersForm AJAX render so that
// "Clear" / filter changes don't revert to the raw labels.
(function () {
  var configEl = document.getElementById("mobile-filter-group-config");
  if (!configEl) return;

  function safeParse(v) {
    if (!v) return null;
    if (typeof v === "string") {
      try {
        return JSON.parse(v);
      } catch (e) {
        return null;
      }
    }
    return v;
  }

  function buildParamToNameMap(raw) {
    var config = safeParse(raw);
    if (typeof config === "string") config = safeParse(config);
    if (!config) return {};
    var groups =
      config.groups || config.filter_groups || config.categories || [];
    var map = {};
    groups.forEach(function (group) {
      var name =
        group.name || group.label || group.display_name || group.title || "";
      var options =
        group.options ||
        group.values ||
        group.filter_options ||
        group.filterOptions ||
        [];
      options.forEach(function (option) {
        var param =
          option.param || option.filter_param || option.metafield_param || "";
        if (param && name && !map[param]) map[param] = name;
      });
    });
    return map;
  }

  var paramToName = buildParamToNameMap(JSON.parse(configEl.textContent));

  function applyMobileFilterGroupNames() {
    document
      .querySelectorAll(".mobile-facets__details[data-filter-param]")
      .forEach(function (el) {
        var param = el.getAttribute("data-filter-param");
        var name = paramToName[param];
        if (!name) return;

        var labelSpan = el.querySelector(
          ".mobile-facets__summary > div > span:first-child",
        );
        if (labelSpan) labelSpan.textContent = name;

        var backBtn = el.querySelector(".mobile-facets__close-button");
        if (backBtn) {
          backBtn.childNodes.forEach(function (node) {
            if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) {
              node.nodeValue = " " + name;
            }
          });
        }
      });
  }

  // Apply on initial load — custom.js is deferred so the DOM is fully parsed.
  applyMobileFilterGroupNames();

  // Patch CollectionFiltersForm so every AJAX render (filter change, clear,
  // back/forward navigation) re-applies the correct names.
  // collection-filters-form.js is deferred and appears before custom.js in the
  // document, so the custom element is already registered when this runs.
  var CollectionFiltersFormClass = customElements.get(
    "collection-filters-form",
  );
  if (CollectionFiltersFormClass) {
    var _renderFilters = CollectionFiltersFormClass.prototype.renderFilters;
    CollectionFiltersFormClass.prototype.renderFilters = function (
      html,
      event,
    ) {
      _renderFilters.call(this, html, event);
      applyMobileFilterGroupNames();
    };
  }
})();

// ── Collection card push-down tilt effect (desktop only) ──────────────────
(function () {
  // Only activate on devices that support hover (desktops, not touchscreens)
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

  var MAX_DEG = 8;

  function applyTilt(card, e) {
    var rect = card.getBoundingClientRect();
    var centeredX = (e.clientX - rect.left) / rect.width - 0.5; // -0.5=left … +0.5=right
    var centeredY = (e.clientY - rect.top) / rect.height - 0.5; // -0.5=top  … +0.5=bottom
    // Rotate so the side under the cursor tilts away ("pressed in" feel)
    var rotX = centeredY * MAX_DEG;
    var rotY = -centeredX * MAX_DEG;
    card.style.transition = "transform 0.06s linear";
    card.style.transform =
      "perspective(700px) rotateX(" + rotX + "deg) rotateY(" + rotY + "deg)";
  }

  function resetTilt(card) {
    card.style.transition = "transform 0.4s ease-out";
    card.style.transform = "perspective(700px) rotateX(0deg) rotateY(0deg)";
  }

  // Event delegation on document — works automatically after filter/AJAX reloads
  document.addEventListener("mousemove", function (e) {
    if (!e.target.closest) return;
    var card = e.target.closest(
      "#main-collection-product-grid .grid-view-item__image",
    );
    if (card) applyTilt(card, e);
  });

  document.addEventListener("mouseout", function (e) {
    if (!e.target.closest) return;
    var card = e.target.closest(
      "#main-collection-product-grid .grid-view-item__image",
    );
    if (!card) return;
    // Only reset when the cursor has actually left the card (not just a child element)
    if (!card.contains(e.relatedTarget)) resetTilt(card);
  });
})();

// ── Default "In Stock" filter on collection pages ──────────────────────────
// If a collection page loads with no filter params at all, pre-check the
// built-in Availability "In stock" checkbox and submit it through the
// existing CollectionFiltersForm AJAX flow — same as a real user click.
// Any existing `filter.*` param in the URL (including a previous explicit
// uncheck, which simply omits the param) is left alone.
(function () {
  var params = new URLSearchParams(window.location.search);
  var hasFilterParam = false;
  params.forEach(function (_, key) {
    if (key.indexOf('filter.') === 0) hasFilterParam = true;
  });
  if (hasFilterParam) return;

  var sidebarForm = document.getElementById('CollectionFiltersFormSidebar');
  var mobileForm = document.getElementById('CollectionFiltersFormMobile');
  if (!sidebarForm && !mobileForm) return; // not a collection page

  var primaryForm = sidebarForm || mobileForm;
  var selector = 'input[name="filter.v.availability"][value="1"]';
  var checkbox = primaryForm.querySelector(selector);
  if (!checkbox || checkbox.checked || checkbox.disabled) return;

  checkbox.checked = true;
  checkbox.dispatchEvent(new Event('input', { bubbles: true }));

  // Reflect the default in the URL immediately (before DOMContentLoaded) so
  // URL-driven filter UIs render it as active — CustomTagFilters reads
  // filter.v.availability from location.search in its constructor. The AJAX
  // flow would update the URL anyway, but only later (debounced).
  // replaceState, not pushState: the unfiltered URL was never really "seen"
  // and must not become a back-button step.
  params.set('filter.v.availability', '1');
  history.replaceState(history.state, '', window.location.pathname + '?' + params);

  // Mirror the checked state onto the other form (sidebar/mobile) so it's
  // visually correct without firing a second redundant AJAX submit.
  var otherForm = primaryForm === sidebarForm ? mobileForm : sidebarForm;
  var otherCheckbox = otherForm && otherForm.querySelector(selector);
  if (otherCheckbox && !otherCheckbox.disabled) otherCheckbox.checked = true;
})();

// ── Search Filters (AJAX faceted filtering for /search) ───────────────────────
(function () {
  var CollectionFiltersFormClass = customElements.get('collection-filters-form');
  if (!CollectionFiltersFormClass) return;

  class SearchFiltersForm extends CollectionFiltersFormClass {
    getSections() {
      const el = document.getElementById('main-search-filters');
      return el ? [{ section: el.dataset.id }] : [];
    }

    renderPage(searchParams, event, updateURLHash = true) {
      const sections = this.getSections();
      const gridEl = document.getElementById('SearchProductGrid');
      if (gridEl) gridEl.classList.add('loading');

      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = element => element.url === url;
        this.filterData.some(filterDataUrl)
          ? this.renderSectionFromCache(filterDataUrl, event)
          : this.renderSectionFromFetch(url, event);
      });

      if (updateURLHash) this.updateURLHash(searchParams);
    }

    renderProductGrid(html) {
      const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = parsedDoc.getElementById('SearchProductGrid');
      const liveGrid = document.getElementById('SearchProductGrid');
      if (newGrid && liveGrid) {
        liveGrid.innerHTML = newGrid.innerHTML;
        liveGrid.classList.remove('loading');
        if (typeof setupWishlistButtons === 'function') setupWishlistButtons();
      }
    }

    renderSectionFromFetch(url, event) {
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          this.filterData = [...this.filterData, { html, url }];
          this.renderFilters(html, event);
          this.renderProductGrid(html);
        })
        .catch((error) => {
          console.error('[SearchFiltersForm] fetch failed:', error);
          const liveGrid = document.getElementById('SearchProductGrid');
          if (liveGrid) liveGrid.classList.remove('loading');
        });
    }

    renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

      // Partial-update desktop and mobile js-filter groups.
      // Skip the group currently being interacted with so its open state is preserved.
      const facetElements = parsedHTML.querySelectorAll(
        '#SearchFiltersForm .js-filter, #SearchFiltersFormMobile .js-filter'
      );
      const matchesIndex = el =>
        el.dataset.index === event?.target.closest('.js-filter')?.dataset.index;
      Array.from(facetElements)
        .filter(el => !matchesIndex(el))
        .forEach(el => {
          const target = document.querySelector(`.js-filter[data-index="${el.dataset.index}"]`);
          if (target) target.innerHTML = el.innerHTML;
        });

      // Swap active-facet chip row (controls its own show/hide via inline style from Liquid)
      const activeFacetsSource = parsedHTML.querySelector('.active-facets-desktop');
      const activeFacetsTarget = document.querySelector('.active-facets-desktop');
      if (activeFacetsSource && activeFacetsTarget) {
        activeFacetsTarget.outerHTML = activeFacetsSource.outerHTML;
      }

      // Swap mobile chip bar
      const mobileSource = parsedHTML.querySelector('.search-filter-chips');
      const mobileTarget = document.querySelector('.search-filter-chips');
      if (mobileSource && mobileTarget) {
        mobileTarget.innerHTML = mobileSource.innerHTML;
      }

      // Chips are reset by the HTML swap — dismiss the backdrop
      const bd = document.getElementById('search-filter-backdrop');
      if (bd) bd.classList.remove('is-visible');

      // Re-bind remove-filter link click handlers on freshly-rendered markup
      document.querySelectorAll('.js-search-facet-remove').forEach(link => {
        link.addEventListener('click', this.onActiveFilterClick.bind(this));
      });

      this.toggleActiveFacets(false);

    }
  }

  customElements.define('search-filters-form', SearchFiltersForm);

  // Bind initial remove-filter links on page load (re-binding after AJAX is handled in renderFilters)
  document.querySelectorAll('search-filters-form').forEach(function (formEl) {
    formEl.querySelectorAll('.js-search-facet-remove').forEach(function (link) {
      link.addEventListener('click', formEl.onActiveFilterClick);
    });
  });

  // ── Search filter chip: backdrop overlay + one-at-a-time behaviour ─────────
  (function () {
    // Create the backdrop once
    var backdrop = document.createElement('div');
    backdrop.id = 'search-filter-backdrop';
    document.body.appendChild(backdrop);

    function setChipBarState(hasOpen) {
      document.querySelectorAll('.search-filter-chips').forEach(function (bar) {
        bar.classList.toggle('has-open-chip', hasOpen);
      });
    }

    function positionOpenDropdown() {
      var openChip = document.querySelector('.search-filter-chip[open]');
      if (!openChip) return;
      var dropdown = openChip.querySelector('.search-filter-chip__dropdown');
      var summary  = openChip.querySelector('summary');
      if (!dropdown || !summary) return;
      var rect = summary.getBoundingClientRect();
      dropdown.style.top  = (rect.bottom + 6) + 'px';
      dropdown.style.left = rect.left + 'px';
    }

    function closeAllChips() {
      document.querySelectorAll('.search-filter-chip[open]')
        .forEach(function (el) { el.removeAttribute('open'); });
      document.querySelectorAll('.search-filter-chip__dropdown')
        .forEach(function (d) { d.style.top = ''; d.style.left = ''; });
      backdrop.classList.remove('is-visible');
      setChipBarState(false);
    }

    // Backdrop click closes everything
    backdrop.addEventListener('click', closeAllChips);

    // Intercept summary clicks: close others, toggle backdrop
    document.addEventListener('click', function (e) {
      var summary = e.target.closest('.search-filter-chip > summary');
      if (!summary) return;

      var chip = summary.closest('.search-filter-chip');
      var willOpen = !chip.hasAttribute('open');

      // Close any other open chip first
      document.querySelectorAll('.search-filter-chip[open]').forEach(function (el) {
        if (el !== chip) el.removeAttribute('open');
      });

      // Backdrop, chip-bar state, and dropdown position follow the chip's new state
      requestAnimationFrame(function () {
        var anyOpen = !!document.querySelector('.search-filter-chip[open]');
        backdrop.classList.toggle('is-visible', anyOpen);
        setChipBarState(anyOpen);
        positionOpenDropdown();
      });
    });

    // Close on outside click (not on a chip or its dropdown)
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.search-filter-chip') && !e.target.closest('#search-filter-backdrop')) {
        closeAllChips();
      }
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllChips();
    });

    // Dismiss on page scroll
    window.addEventListener('scroll', closeAllChips, { passive: true });
  }());
})();

/* ============================================================
   Night Mode — Display Preferences panel interactivity.
   Initial veil state is applied pre-paint by assets/night-mode.js;
   this wires the controls, persistence, open/close, and the live
   OS-preference listener.
   ============================================================ */
(function () {
  function init() {
    var NM = window.NightMode;
    var panel = document.getElementById("display-prefs-panel");
    if (!NM || !panel) return;

    var triggers = document.querySelectorAll(".js-display-prefs-trigger");
    var pills = panel.querySelectorAll(".display-prefs__pill");

    function currentValue(prefName) {
      var prefs = NM.readPrefs();
      var v = prefs[prefName];
      return v != null ? v : NM.DEFAULTS[prefName];
    }

    function syncPills() {
      pills.forEach(function (pill) {
        var on =
          pill.getAttribute("data-value") ===
          currentValue(pill.getAttribute("data-pref"));
        pill.classList.toggle("display-prefs__pill--active", on);
        pill.setAttribute("aria-checked", on ? "true" : "false");
      });
    }

    function applyState() {
      NM.apply(NM.resolve(NM.readPrefs(), NM.prefersDark()));
      syncPills();
    }

    // Choosing a pill: persist + re-apply live
    pills.forEach(function (pill) {
      pill.addEventListener("click", function () {
        NM.savePref(pill.getAttribute("data-pref"), pill.getAttribute("data-value"));
        applyState();
      });
    });

    // Open / close
    function isOpen() {
      return !panel.hidden;
    }
    function setExpanded(state) {
      triggers.forEach(function (t) {
        t.setAttribute("aria-expanded", state ? "true" : "false");
      });
    }
    function openPanel() {
      panel.hidden = false;
      setExpanded(true);
    }
    function closePanel() {
      panel.hidden = true;
      setExpanded(false);
    }

    triggers.forEach(function (t) {
      t.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (isOpen()) closePanel();
        else openPanel();
      });
    });

    document.addEventListener("click", function (e) {
      if (!isOpen()) return;
      if (panel.contains(e.target)) return;
      if (e.target.closest(".js-display-prefs-trigger")) return;
      closePanel();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen()) closePanel();
    });

    // Live OS appearance changes (only matters while nightMode === "auto")
    if (typeof window.matchMedia === "function") {
      var mq = window.matchMedia("(prefers-color-scheme: dark)");
      var onChange = function () {
        applyState();
      };
      if (mq.addEventListener) mq.addEventListener("change", onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }

    // Enable veil transitions now that the first paint is done, and
    // reflect the current saved state in the pills.
    document.documentElement.classList.add("night-ready");
    syncPills();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ============================================================
   Event detail accordions — "Event Description" / "Prizing"
   Independent sections (expanding one never collapses the
   other), unlike the strict tier-3 nav accordion. The detail
   DOM is created dynamically by CalendarV2, so delegate.
   ============================================================ */
jQuery(function ($) {
  $(document).on("click", ".js-event-acc-toggle", function (e) {
    e.preventDefault();
    var $toggle = $(this);
    var $collapse = $toggle.next(".event-acc__collapse");
    var open = $collapse.toggleClass("is-open").hasClass("is-open");
    $toggle.attr("aria-expanded", open ? "true" : "false");

    // List-view expands sit inside a ReactCollapse wrapper whose inline
    // max-height was measured once at insert; re-measure after our 300ms
    // animation so newly revealed content isn't clipped.
    var $outer = $toggle.closest(".ReactCollapse--collapse");
    if ($outer.length) {
      setTimeout(function () {
        $outer.css("max-height", $outer[0].scrollHeight + "px");
      }, 320);
    }
  });
});

/* === Quiet chrome — auto-hiding fixed header (Unit 29) ===
   Pure hysteresis lives in assets/header-hide.js (unit-tested); this
   section only wires the DOM. shop.js owns adding/removing
   .fixed-header — we never touch it, only observe. DOM writes happen
   ONLY when state.hidden flips. */
(function () {
  var HH = window.HeaderHide;
  if (!HH || !document.body) return;

  var tab = document.createElement("button");
  tab.type = "button";
  tab.className = "tgd-menu-tab";
  tab.hidden = true;
  tab.setAttribute("aria-label", "Show menu");
  tab.setAttribute("aria-controls", "header");
  tab.setAttribute("aria-expanded", "true");
  tab.innerHTML = 'Menu <span aria-hidden="true">▾</span>';
  document.body.appendChild(tab);

  var state = { hidden: false, downAccum: 0 };
  // Seed with the CURRENT position: a bfcache restore or anchor
  // deep-link lands mid-page, and a zero seed would read as a huge
  // down-delta that hides the header on the first nudge.
  var lastScrollY = window.scrollY;
  var ticking = false;

  function overlayOpen() {
    // Three surfaces, three different open signals (all verified):
    // tier-1 tray drops its --hidden CLASS; prefs panel drops its
    // hidden ATTRIBUTE; mobile popup is jQuery show/hide inline display.
    if (document.querySelector(".main-menu__sub-menu-container:not(.main-menu__sub-menu-container--hidden)")) return true;
    var prefs = document.getElementById("display-prefs-panel");
    if (prefs && !prefs.hidden) return true;
    var mob = document.getElementById("mobile_top_menu_wrapper");
    if (mob && window.getComputedStyle(mob).display !== "none") return true;
    return false;
  }

  function applyState(next) {
    if (next.hidden !== state.hidden) {
      document.documentElement.classList.toggle("tgd-header-hidden", next.hidden);
      tab.hidden = !next.hidden;
      tab.setAttribute("aria-expanded", next.hidden ? "false" : "true");
    }
    state = next;
  }

  function onFrame() {
    ticking = false;
    var y = window.scrollY;
    var frame = {
      deltaY: y - lastScrollY,
      scrollY: y,
      fixed: !!document.querySelector(".fixed-header"),
      overlayOpen: overlayOpen()
    };
    lastScrollY = y;
    applyState(HH.headerHideNext(state, frame));
  }

  window.addEventListener("scroll", function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(onFrame);
  }, { passive: true });

  tab.addEventListener("click", function () {
    applyState({ hidden: false, downAccum: 0 });
  });
})();

/* ============================================================
   Moving announcement bar — reveal, expand/collapse, dismissal
   The bar's first reveal is a synchronous inline script in
   snippets/moving-announcement-bar.liquid (pre-paint, so a
   dismissed bar never flashes). That inline script does NOT run
   in the theme editor, which re-renders a section by inserting
   its HTML — inserted script elements never execute — so the
   bar would sit there [hidden] at the exact moment the merchant
   ticks it on. Re-run the same reveal here and on
   shopify:section:load. Dismissal stores the bar's version
   string, so bumping "Message version" in the customizer
   re-shows it to everyone.
   ============================================================ */
(function () {
  var STORAGE_KEY = "tgd-move-bar-dismissed";

  function dismissedVersion() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null; // Private mode: treat as never dismissed.
    }
  }

  /* The bar lives INSIDE .nav-header, and shop.js snapshots
     `$('.nav-header').outerHeight(true)` into stickyTopDistance at ready and
     on resize only (shop.js:45-46). ANY change to the bar's height —
     revealing it, dismissing it, expanding the panel — invalidates that
     snapshot, and a stale one makes the header fix early or late and snap
     mid-scroll. shop.js binds mediaSize with window.addEventListener, so a
     synthetic resize re-runs it; every other resize listener in the theme is
     debounced relayout that wants this signal anyway (the header height
     really did change). */
  var remeasurePending = false;

  function headerIsFixed() {
    return !!document.querySelector(".fixed-header");
  }

  /* Never remeasure while the header is fixed. shop.js:33 puts an inline
     `margin-bottom: stickyTopMargin` on #header .nav-header in the sticky
     state, and its own recompute uses outerHeight(true), which INCLUDES
     margin — so a resize fired now writes back a threshold inflated by a
     whole header row, and the header un-fixes ~100px early on the way back
     up. Escape is the only bar control reachable while scrolled (the strip
     and ✕ scroll away with .nav-header), which is how this is reachable.

     Defer rather than drop: simply skipping would leave the threshold stale
     by the panel's height, which is fine for a short panel but WORSE than
     the corruption once the details grow taller than the header row. So
     wait for shop.js to un-fix (it clears the inline margin at the same
     time) and measure then. shop.js registers its scroll handler at ready,
     before this one, so by the time we look the class is already gone. */
  function remeasureStickyHeader() {
    if (headerIsFixed()) {
      scheduleRemeasure();
      return;
    }
    window.dispatchEvent(new Event("resize"));
  }

  function scheduleRemeasure() {
    if (remeasurePending) return;
    remeasurePending = true;
    window.addEventListener("scroll", function onScroll() {
      if (headerIsFixed()) return;
      window.removeEventListener("scroll", onScroll);
      remeasurePending = false;
      window.dispatchEvent(new Event("resize"));
    }, { passive: true });
  }

  // Idempotent: safe to call on every section re-render.
  function revealMoveBar() {
    var bar = document.getElementById("tgd-move-bar");
    if (!bar) return;
    var next = dismissedVersion() === bar.getAttribute("data-move-bar-version");
    if (bar.hidden === next) return; // No height change — don't fire a spurious resize.
    bar.hidden = next;
    remeasureStickyHeader();
  }

  function setExpanded(toggle, open) {
    var panel = document.getElementById(
      toggle.getAttribute("aria-controls")
    );
    if (!panel) return;
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    panel.classList.toggle("is-open", open);
    /* visibility only flips once the 250ms collapse finishes, leaving the
       content focusable AND actionable in the meantime — Tab, Tab, Enter
       could navigate from a panel that is closing. `inert` removes it from
       focus and the a11y tree immediately without affecting paint, so the
       animation still looks right. Ignored by browsers that lack it, which
       fall back to the visibility behaviour. */
    panel.inert = !open;
    /* Remeasure twice on purpose. The immediate call is the correct final
       height under prefers-reduced-motion, where transition is none and
       transitionend never fires at all; the transitionend call below is the
       authoritative one once the 0fr/1fr animation has actually finished. */
    remeasureStickyHeader();
  }

  // Delegated, so a section re-render swapping the node keeps working
  // without rebinding.
  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;

    var toggle = e.target.closest(".js-move-bar-toggle");
    if (toggle) {
      setExpanded(toggle, toggle.getAttribute("aria-expanded") !== "true");
      return;
    }

    /* The close button is a SIBLING of the toggle, not a descendant, so this
       branch can't be reached by a click that also toggled. */
    var btn = e.target.closest(".js-move-bar-close");
    if (!btn) return;
    var bar = btn.closest(".tgd-move-bar");
    if (!bar) return;
    bar.hidden = true;
    remeasureStickyHeader();
    try {
      localStorage.setItem(STORAGE_KEY, bar.getAttribute("data-move-bar-version"));
    } catch (e2) {
      /* Private mode: the bar simply returns next load. */
    }
  });

  // Escape collapses the panel; it does NOT dismiss the bar (that's the ✕).
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var toggle = document.querySelector(
      '.js-move-bar-toggle[aria-expanded="true"]'
    );
    if (toggle) setExpanded(toggle, false);
  });

  /* Authoritative remeasure: the panel's height is only final once the
     grid-template-rows transition ends. Guarded to that property so the
     chevron's transform transition doesn't also fire a resize. */
  document.addEventListener(
    "transitionend",
    function (e) {
      if (e.propertyName !== "grid-template-rows") return;
      if (!e.target.classList || !e.target.classList.contains("tgd-move-bar__panel")) return;
      remeasureStickyHeader();
    },
    true
  );

  document.addEventListener("shopify:section:load", revealMoveBar);
  revealMoveBar();
})();
